import { Component, OnInit, Output, EventEmitter, Input, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { startWith } from 'rxjs/operators';
import { Studio } from 'src/app/models/studio';
import { AuthService } from 'src/app/services/auth.service';
import { BufferedInputComponent } from 'src/app/shared/custom-form-controls/buffered-input/buffered-input.component';

@Component({
  selector: 'search-incarichi',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, AfterViewInit {

  @Input() search: any;
  @Output() searchChange = new EventEmitter();
  studioRicercaDefault: Studio;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
  ) { }

  form: FormGroup;

  ngOnInit(): void {

    this.studioRicercaDefault = this.authService.studioForDefaultSearch();

    this.form = this.fb.group({
      numero: [this.search?.numero],
      stato: [this.search?.stato],
      data: [this.search?.data],
      data_sinistro: [this.search?.data_sinistro],
      data_sopralluogo: [this.search?.data_sopralluogo],
      data_spedizione: [this.search?.data_spedizione],
      data_scadenza: [this.search?.data_scadenza],
      tipo_danno: [this.search?.tipo_danno],
      studio: [this.search?.studio ?? this.studioRicercaDefault],
      filiale: [this.search?.filiale],
      broker: [this.search?.broker],
      polizza: [this.search?.polizza],
      agenzia: [this.search?.agenzia],
      compagnia: [this.search?.compagnia],
      ispettorato: [this.search?.ispettorato],
      contraente: [this.search?.contraente],
      denominazione_contraente: [this.search?.denominazione_contraente],
      firmatario: [this.search?.firmatario],
      incaricato: [this.search?.incaricato],
      auditor: [this.search?.auditor],
      evasore: [this.search?.evasore],
      liquidatore: [this.search?.liquidatore],
      accertatore: [this.search?.accertatore],
      inseritore: [this.search?.inseritore],
      numero_sinistro: [this.search?.numero_sinistro],
      controparte: [this.search?.controparte],
      amministratore: [this.search?.amministratore],
      stato_videoperizia: [this.search?.stato_videoperizia],
      stato_riparazione: [this.search?.stato_riparazione],
      note: [this.search?.note],
      gruppo_rami: [this.search?.gruppo_rami],
      comune: [this.search?.comune],
      cap: [this.search?.cap],
      via: [this.search?.via],
      provincia: [this.search?.provincia],
      zona_geografica: [this.search?.zona_geografica],
      over_10000: [this.search?.over_10000],
      over_50000: [this.search?.over_50000],
      globale_fabbricati: [this.search?.globale_fabbricati],
      riserva: [this.search?.riserva],
      pronta_liquidazione: [this.search?.pronta_liquidazione],
      foto_attestati_danno: [this.search?.foto_attestati_danno],
      documento_contabile_opere_ripristino: [this.search?.documento_contabile_opere_ripristino],
      sopralluoghi_da_effettuare: [this.search?.sopralluoghi_da_effettuare],
      sollecitato: [this.search?.sollecitato],
      ramo: [this.search?.ramo],
      cga: [this.search?.cga],
    });

    this.form.valueChanges.pipe(
      startWith(this.form.value)
    ).subscribe(v => {
      const normalized = { ...v } as any;
      if (typeof normalized.numero_sinistro === 'string') {
        normalized.numero_sinistro = normalized.numero_sinistro.trim();
      }
      this.searchChange.emit(normalized);
    });


  }

  reset() {
    this.searchChange.emit({});
    this.form = null;

    setTimeout(
      () => this.ngOnInit(), 0
    )
  }

  @ViewChild("focusMePls") focusMePls: BufferedInputComponent;
  //Per autofocusare l'input del numero di incarico è necessario setTimeout dentro all'afterViewInit
  ngAfterViewInit() {
    //This seems hacky but it's the official suggestion.
    //https://stackoverflow.com/a/38846793/9988983
    setTimeout(() => {
      this.focusMePls?.userTypesHere?.nativeElement?.focus();
      this.focusMePls?.userTypesHere?.nativeElement?.select();
    });
  }
}
